module.exports = __webpack_public_path__ + "static/First_Data_Graphics_Reel-618eb179d2ada0750980b2b2f6d26a60.mp4";